/**
 * @desc getLogisticsGroup
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.LogisticsGroupResponseDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/test/getLogisticsGroup`, {
      method: "GET",

      ...options,
    }),
  );
}
